/**
 * Controlli mappa allineati ai gruppi nativi MapLibre (`.maplibregl-ctrl-group`):
 * stack verticale, divisori tra i pulsanti, ombra sul contenitore — non sul singolo bottone.
 * @param {import('@mui/material').Theme} theme
 */

/** Larghezza/altezza come i pulsanti `.maplibregl-ctrl-group` nativi (~30px). */
export const MAPLIBRE_CTRL_BTN_SIZE = 30

/**
 * Pulsante MUI `Button` dentro un gruppo MapLibre (no ombra, no radius, no bordo esterno).
 * Usare con classe `fred-map-toolbar-btn` per i divisori via CSS.
 * @param {import('@mui/material').Theme} theme
 */
export function maplibreGroupChildButtonSx(theme) {
  const isLight = theme.palette.mode === 'light'
  const bg = isLight ? theme.palette.background.paper : theme.palette.background.paper
  const iconColor = isLight
    ? theme.palette.newColors?.gray || 'rgba(0, 0, 0, 0.87)'
    : theme.palette.newColors?.lightGray || theme.palette.text.primary
  return {
    width: MAPLIBRE_CTRL_BTN_SIZE,
    minWidth: MAPLIBRE_CTRL_BTN_SIZE,
    height: MAPLIBRE_CTRL_BTN_SIZE,
    padding: 0,
    borderRadius: 0,
    boxShadow: 'none',
    // No `border: none`: lascia libero il border-top dei successivi (vedi index.css `.fred-map-toolbar-btn ~ …`)
    borderLeftWidth: 0,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    borderTopWidth: 0,
    borderLeftStyle: 'none',
    borderRightStyle: 'none',
    borderBottomStyle: 'none',
    borderTopStyle: 'none',
    borderColor: 'transparent',
    backgroundColor: bg,
    color: iconColor,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      backgroundColor: isLight
        ? theme.palette.newColors?.lightGray || '#f2f2f2'
        : theme.palette.action.hover,
    },
  }
}

/**
 * `IconButton` nello stesso gruppo (es. stile mappa).
 * @param {import('@mui/material').Theme} theme
 */
export function maplibreGroupChildIconButtonSx(theme) {
  return {
    ...maplibreGroupChildButtonSx(theme),
    borderRadius: 0,
  }
}
